import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Button,
  Container,
  InputAdornment,
  Pagination,
  PaginationItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import ConfirmationModel from "components/ConfirmationModel";
import FilterBar from "components/FilterBar";
import Loader from "components/Loader";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  changePagination,
  deleteClientById,
  getAdminClients,
  searchClients,
} from "store/actions/admin/clients";
import { setHeaderDetails } from "store/actions/header";
import { clientStatuses } from "utils/programs.utils";
import ClientListBody from "./ClientsListBody";
import ClientListHeader from "./ClientsListHeader";
import InviteClient from "./InviteClient";

const MyAdminClientsList = () => {
  const dispatch = useDispatch();
  const clients = useSelector((state) => state.admin.clients.clients);

  const isLoadingClients = useSelector(
    (state) => state.admin.clients.isLoadingClients
  );

  const currentPage = useSelector((state) => state.admin.clients.currentPage);

  const [current, setCurrent] = useState(null);
  const [showDeleteModel, setDeleteModel] = useState(false);
  const [showInviteClientModal, setShowInviteClientModal] = useState(false);
  const start = (currentPage - 1) * 10;
  const end = start + 10;
  const currentPageItems = (clients || []).slice(start, end).length;
  const [filters, setFilters] = useState([]);
  const [subscriptionFilters, setSubscriptionFilters] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const toggleDeleteModel = (ele = "") => {
    setDeleteModel(!showDeleteModel);
    setCurrent(ele);
  };

  const toggleInviteClientModal = () => {
    setCurrent(null);
    setShowInviteClientModal(!showInviteClientModal);
  };
  const openClientDetails = (ele) => {
    setCurrent(ele);
    setShowInviteClientModal(true);
  };
  useEffect(() => {
    dispatch(getAdminClients());
    const navDetail = {
      isBreadcrumns: false,
      title: "Clients",
    };

    dispatch(setHeaderDetails(navDetail));
  }, []);
  const getStatusFilterValues = (values) => {
    setFilters(values);
    dispatch(searchClients(searchQuery, values, subscriptionFilters));
  };

  const getSubscriptionFilterValues = (values) => {
    setSubscriptionFilters(values);
    dispatch(searchClients(searchQuery, filters, values));
  };
  return (
    <>
      <Container
        maxWidth="xxl"
        className="header-box"
        sx={{ padding: "0 !important", marginBottom: "20px" }}
      >
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems={{ xs: "stretch", sm: "center" }}
          justifyContent="space-between"
          gap={1}
          mt={2}
        >
          <Stack
            direction={{ xs: "column", sm: "row" }}
            alignItems={{ xs: "stretch", sm: "center" }}
            gap={1}
          >
            <TextField
              placeholder="Rechercher un client"
              name="Rechercher un client"
              size="small"
              sx={{
                width: { sm: "100%", md: "414px" },
                ".MuiInputBase-root": {
                  background: "#ffffff",
                  borderRadius: "8px",
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="#4F5668" />
                  </InputAdornment>
                ),
              }}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                dispatch(searchClients(e.target.value, filters));
              }}
            />
            <FilterBar
              filters={[
                { title: "Statut", list: clientStatuses, onSelect: getStatusFilterValues },
                {
                  title: "Abonnement",
                  list: [
                    { id: 1, name: "Evo Free" },
                    { id: 2, name: "Evo Basic" },
                    { id: 3, name: "Evo Pro" },
                    { id: 4, name: "Evo Master" },
                  ],
                  onSelect: getSubscriptionFilterValues,
                },
              ]}
            />
          </Stack>
          <Button
            size="small"
            color="primary"
            variant="contained"
            sx={{ width: { xs: "100%", sm: "auto" } }}
            onClick={() => {
              setShowInviteClientModal(true);
            }}
          >
            Ajouter un client
          </Button>
        </Stack>
      </Container>
      <Container maxWidth="xxl">
        <Stack gap={1}>
          <Loader isLoading={isLoadingClients} />
          {!isLoadingClients && <ClientListHeader />}
          {(clients || []).length === 0 && !isLoadingClients && (
            <Box component="h5" textAlign="center">
              Vous n'avez pas encore de clients.
            </Box>
          )}

          {!isLoadingClients && (
            <Box sx={{ minHeight: "544px" }}>
              {(clients || []).slice(start, end).map((client, index) => (
                <ClientListBody
                  key={client._id}
                  client={client}
                  toggleDeleteModel={toggleDeleteModel}
                  openClientDetails={openClientDetails}
                />
              ))}
            </Box>
          )}
          {!isLoadingClients && (clients || []).length > 10 && (
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography color="#000000" fontSize="12px" fontWeight="500">
                Affichage de {start + 1} à {start + currentPageItems} sur{" "}
                {clients.length} résultats
              </Typography>
              <Pagination
                page={currentPage}
                onChange={(page, value) => dispatch(changePagination(value))}
                count={Math.ceil(clients.length / 10)}
                variant="outlined"
                shape="rounded"
                color="secondary"
                size="small"
                siblingCount={0}
                renderItem={(item) => (
                  <PaginationItem
                    slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                    {...item}
                  />
                )}
              />
            </Stack>
          )}
        </Stack>
        <InviteClient
          showModal={showInviteClientModal}
          toggleInviteClientModal={toggleInviteClientModal}
          clientDetails={current}
        />
        <ConfirmationModel
          isOpen={showDeleteModel}
          title="Supprimer Client"
          body={[
            "Vous allez supprimer ce client. Cette action est irréversible. Pour continuer, cliquez sur Supprimer.",
          ]}
          handleClose={toggleDeleteModel}
          maxWidth="sm"
          onConfirm={() => {
            dispatch(deleteClientById(current._id, toggleDeleteModel)).then(
              () => toggleDeleteModel()
            );
          }}
        />
      </Container>
    </>
  );
};

export default MyAdminClientsList;
